<script setup lang="ts">
import { ref, watch } from 'vue';
import ExpandableImage from '@components/expandable-image.vue';
import { aspectRatioType, sizeType } from '@components/expandable-image-types.ts';
import apiClient, { createApiErrorModal } from '@src/api/api-client.ts';
import { ApiError } from '@src/api/api-error';

const { idManufacturer, spread = true } = defineProps<{
    idManufacturer: number;
    border?: boolean;
    aspectRatio?: aspectRatioType|false;
    size?: sizeType|false;
    spread?: boolean;
    maxHeight?: string;
}>();

const logoUrl = ref<string|null>(null);

async function setLogoUrl() {
    const request = apiClient.get('/be/manufacturer/logo/' + idManufacturer);
    request.setCustomErrorHttpCodes(404);
    try {
        const logo = (await request).data;
        const blob = new Blob([logo], { type: 'image/svg+xml' });
        logoUrl.value = URL.createObjectURL(blob);
    } catch (e: any) {
        if (!(e instanceof ApiError) || e.code !== 'MANUFACTURER_LOGO_NOT_FOUND') {
            createApiErrorModal(e);
            throw e;
        }
        console.warn('Kein Logo vorhanden.');
    }
}

await setLogoUrl();

watch(() => idManufacturer, setLogoUrl);
</script>

<template>
    <div :class="[$style.logo, border ? $style.border : '', !spread ? $style.inline : '']">
        <ExpandableImage
            :path="logoUrl"
            :size="size"
            :aspect-ratio="aspectRatio"
            :max-height="maxHeight"
        />
    </div>
</template>

<style lang="scss" module>
@use '@borders' as *;

.logo {
    display: flex;
    align-items: center;
    justify-content: center;

    &.inline {
        display: inline-flex;
    }
    &.border {
        padding: .5em;
        border: $thin-line-grey;
    }
}
</style>
